const errors = new Map([
  [0, undefined],
  [1, "unknown error"],
  [2, "file not found or could not be opened"],
  [3, "file not in PDF format or corrupted"],
  [4, "password required or incorrect password"],
  [5, "unsupported security scheme"],
  [6, "page not found or content error"],
])

export function GetLastError(pdfium) {
  const code = pdfium.FPDF_GetLastError()
  return errors.has(code) ? errors.get(code) : "unknown error"
}
